import connectedStore from '../connected-store';

const dispatchAwaitableAction = (action) => {
  const store = connectedStore.get();
  return new Promise((__resolve__, __reject__) => {
    const asyncAction = {
      ...action,
      payload: {
        ...action.payload,
        __resolve__,
        __reject__,
      },
    };
    store.dispatch(asyncAction);
  });
};

export default dispatchAwaitableAction;
